export default __webpack_public_path__ + "static/media/facebook.5016a88f.webp";